<template>
    <a v-if="to" :href="to" class="primary-link">
        <slot />
    </a>

    <button v-else class="primary-link">
        <slot />
    </button>
</template>

<script>
export default {
  name: "BaseLink",
  props: {
    to: {
      type: String,
    },
  }
}
</script>
